export const enGB_system = {
	'app.system.login.username': 'User Name',
	'app.system.login.phone': 'Phone Number',
	'app.system.login.password': 'User Password',
	'app.system.login.pincode': 'Pin Code',
	'app.system.login.privacy': 'I agree to the Terms of Service and Privacy Policy.',
	'app.system.login.registry': 'Registry',
	'app.system.login.login': 'Login',
	'app.system.login.getpincode': 'Get Pincode',
	'app.system.common': 'system common',
	'app.system.common.user.center': 'User Center',
	'app.system.common.user.setting': 'User Setting',
	'app.system.common.user.logout': 'User Logout',
	'app.common.language.chinese': '中文',
	'app.system.common.list': ' List',
	'app.system.common.button.query': 'query',
	'app.system.common.button.create': 'create',
	'app.system.common.button.cancel': 'cancel',
	'app.system.common.button.reset': 'reset',
	'app.system.common.button.detail': 'detail',
	'app.system.common.button.edit': 'edit',
	'app.system.common.button.delete': 'delete',
	'app.system.common.button.export': 'Export',
	'app.system.common.button.copy': 'Copy',
	'app.system.common.button.more': 'More',
	'app.system.common.button.copyException': 'Copy Exception Stack',
	'app.system.common.button.exportRow': 'Export This Row',
	'app.system.common.button.save': 'Save',
	'app.system.common.button.refresh': 'Refresh',
	'app.system.common.button.expand': 'Expand',
	'app.system.common.button.collapse': 'Collapse',
	'app.system.common.query.like': 'like search',
	'app.system.common.input': 'Please input',
	'app.system.common.select': 'Please select',
	'app.system.common.operator': 'operator',
	'app.system.common.create.time': 'crateTime',
	'app.system.common.create.operator': 'createOperator',
	'app.system.common.update.time': 'updateTime',
	'app.system.common.update.operator': 'updateOperator',
	'app.system.role': 'Role',
	'app.system.role.name': 'Role Name',
	'app.system.role.code': 'Role Code',
	'app.system.permission': 'Permission',
	'app.system.permission.name': 'Permission Name',
	'app.system.permission.code': 'Permission Code',
	'app.system.dept': 'dept',
	'app.system.dept.name': 'dept Name',
	'app.system.dept.parent': 'parent Dept Name',
	'app.system.account': 'account',
	'app.system.account.nickname': 'Nick Name',
	'app.system.account.name': 'Login Name',
	'app.system.account.password': 'account Password',
	'app.system.account.phone': 'concat Phone',
	'app.system.account.email': 'concat Email',
	// Common prompt text
	'app.common.success.create': 'Created successfully',
	'app.common.success.update': 'Saved successfully',
	'app.common.success.avatar': 'Avatar updated successfully',
	'app.common.success.export': 'Exported successfully',
	'app.common.error.export': 'Export failed',
	'app.common.loading': 'Loading...',
	'app.common.error.select.parent': 'Please select a parent department',
	'app.common.error.password.required': 'Account password cannot be empty',
	'app.common.error.nickname.required': 'Nickname cannot be empty',
	'app.common.error.dept.required': 'Department cannot be empty',
	'app.common.error.roleName.required': 'Role name cannot be empty',
	'app.common.error.roleCode.required': 'Role code cannot be empty',
	'app.common.error.permissionName.required': 'Permission name is required',
	'app.common.error.codeType.required': 'Code type is required',
	'app.common.error.codeDesc.required': 'Code description is required',
	'app.common.error.codeValue.required': 'Code value is required',
	'app.common.error.noticeTitle.required': 'Notice title is required',
	'app.common.error.jobName.required': 'Job name is required',
	'app.common.error.jobGroup.required': 'Job group is required',
	'app.common.error.cronExpression.required': 'Cron expression is required',
	'app.common.error.invokeTarget.required': 'Invoke target is required',
	'app.system.permission.systemMenu': 'System Menu',
	'app.common.label.permissionList': 'Permission List',
	'app.common.label.accountDepts': 'Account Departments',
	'app.common.label.nickname': 'Nickname',
	'app.common.label.avatar': 'Avatar',
	'app.common.label.email': 'Email',
	'app.common.label.phone': 'Phone',
	'app.common.label.profile': 'Profile',
	'app.common.label.oldPassword': 'Old Password',
	'app.common.label.newPassword': 'New Password',
	'app.common.label.confirmPassword': 'Confirm New Password',
	'app.common.placeholder.nickname': 'Please enter nickname',
	'app.common.placeholder.email': 'Please enter email',
	'app.common.placeholder.phone': 'Please enter phone',
	'app.common.placeholder.profile': 'Please enter profile',
	'app.common.placeholder.oldPassword': 'Please enter old password',
	'app.common.placeholder.newPassword': 'Please enter new password',
	'app.common.placeholder.confirmPassword': 'Please confirm new password',
	'app.common.success.save': 'Saved successfully',
	'app.common.error.save': 'Failed to save',
	'app.common.error.deptName.required': 'Department name cannot be empty',
	'app.common.error.role.required': 'Role cannot be empty',
	// Common confirm text
	'app.common.confirm.delete.title': 'Are you sure you want to delete this item?',
	'app.common.confirm.delete.content': 'Please confirm, deletion cannot be undone',
	'app.common.confirm.discard.title': 'Confirm discard changes?',
	'app.common.confirm.discard.content': 'Unsaved changes will be lost.',
	'app.common.confirm.execute.title': 'Are you sure you want to manually execute?',
	'app.common.confirm.execute.content': 'Please confirm whether to execute this task immediately',
	'app.common.confirm.resume.title': 'Are you sure you want to enable this task?',
	'app.common.confirm.resume.content': 'Please confirm whether to enable this scheduled task',
	'app.common.confirm.pause.title': 'Are you sure you want to disable this task?',
	'app.common.confirm.pause.content': 'Please confirm whether to disable this scheduled task',
	'app.common.success.resume': 'Enabled successfully',
	'app.common.success.pause': 'Disabled successfully',
	// Global search
	'app.common.search.placeholder': 'Search...',
	'app.common.search.recent': 'Recent',
	'app.common.search.empty': 'Type to search',
	'app.common.search.noResult': 'No matching results',
	'app.common.search.hint': '↑↓ Navigate · Enter to open · Esc to close',
	'app.common.search.hotkey': '⌘K',
	// Account related
	'app.system.account.deptName': 'Department Name',
	'app.system.account.roleName': 'Role Name',
	'app.system.account.lastLoginTime': 'Last Login Time',
	'app.system.account.accountRoles': 'Account Roles',
	// User settings related
	'app.system.settings.basic': 'Basic Settings',
	'app.system.settings.security': 'Security Settings',
	'app.system.settings.accountBinding': 'Account Binding',
	'app.system.settings.saveBasic': 'Save Basic Info',
	'app.system.settings.saveSecurity': 'Save Security Settings',
	// Account binding status
	'app.common.status.bound': 'Bound',
	'app.common.status.unbound': 'Not Bound',
	'app.common.button.bind': 'Bind',
	'app.common.button.unbind': 'Unbind',
	// Column setting
	'app.system.common.button.columnSetting': 'Columns',
	'app.system.common.columnSetting.title': 'Visible Columns',
	'app.system.common.columnSetting.checkAll': 'Select All',
	'app.system.common.columnSetting.reset': 'Reset',
	// Login related
	'app.system.login.usernamePlaceholder': 'Initial account admin',
	'app.system.login.phonePlaceholder': 'Initial phone number 15500000000',
	'app.system.login.passwordPlaceholder': 'Initial password 123456',
	'app.system.login.pincodePlaceholder': 'Initial pincode 123456',
	'app.system.login.welcome': 'Welcome to the system',
	'app.system.login.or': 'Or',
	'app.system.login.type': 'Login Method',
	'app.system.login.type.account': 'Account',
	'app.system.login.type.phone': 'Phone',
	'app.system.login.type.github': 'GitHub',
	'app.system.login.type.feishu': 'Feishu',
	'app.system.login.type.wechat': 'WeChat',
	'app.system.login.signInWith': 'Sign in with {provider}',
	'app.system.login.oauthDesc': 'Click the button below to authorize with {provider}',
	'app.system.login.continue': 'Continue',
	'app.system.login.wechat.scanHint': 'Open WeChat and scan the QR code',
	'app.system.login.demo.title': 'Demo Accounts',
	'app.system.login.demo.hint': 'For open-source demo · Click to autofill',
	'app.system.login.demo.admin': 'Admin',
	'app.system.login.demo.adminDesc': 'Administrator · Full access',
	'app.system.login.demo.test': 'Test',
	'app.system.login.demo.testDesc': 'Test account · Limited access',
	// Workbench related
	'app.system.workbench.title': 'Workbench',
	'app.system.workbench.teamRanking': 'Team Ranking',
	'app.system.workbench.compareYesterday': 'Compared to yesterday',
	'app.system.workbench.projectAccess': 'Project Access',
	'app.system.workbench.greeting': 'Hello {name}, have a nice day',
	'app.system.workbench.systemNotice': 'System Notice',
	'app.system.workbench.recentActivity': 'Recent Activity',
	'app.system.workbench.more': 'More',
	'app.system.workbench.timeAgo': '7 minutes ago',
	'app.system.workbench.quickNavigation': 'Quick Navigation',
	'app.system.workbench.operation': 'Operation',
	'app.system.workbench.add': 'Add',
	'app.system.workbench.salesIndex': 'Sales Index',
	// Config related
	'app.config.code.title': 'Dictionary Management',
	'app.config.code.detailTitle': 'Dictionary Detail',
	'app.config.code.table.codeId': 'Dictionary ID',
	'app.config.code.table.codeType': 'Dictionary Type',
	'app.config.code.table.codeLabel': 'Dictionary Value',
	'app.config.code.table.codeValue': 'Dictionary Code',
	'app.config.code.table.codeDesc': 'Dictionary Description',
	'app.config.code.label.codeType': 'Dictionary Type',
	'app.config.code.label.codeDesc': 'Dictionary Description',
	'app.config.code.label.codeValue': 'Dictionary Code',
	'app.config.code.label.codeLabel': 'Dictionary Value',
	'app.config.code.placeholder.codeDesc': 'Please enter dictionary description',
	'app.config.menu.title': 'Menu Management',
	'app.config.menu.detailTitle': 'Menu Detail',
	'app.config.menu.table.menuId': 'Menu ID',
	'app.config.menu.table.parentMenuId': 'Parent Menu',
	'app.config.menu.table.i18n': 'i18n',
	'app.config.menu.table.iconName': 'Icon Name',
	'app.config.menu.table.menuPath': 'Menu Path',
	'app.config.menu.table.orderNum': 'Menu Order',
	'app.config.menu.table.hiddenMenu': 'Hidden',
	'app.config.menu.label.parentMenuId': 'Parent Menu',
	'app.config.menu.label.iconName': 'Icon Name',
	'app.config.menu.label.orderNum': 'Menu Order',
	'app.config.menu.tooltip.parentMenuId': 'To create a top-level menu, select the top-level entry as parent',
	'app.config.menu.placeholder.iconName': 'Please select a menu icon',
	'app.common.error.orderNum.required': 'Menu order is required',
	'app.common.error.textKey.required': 'i18n key is required',
	'app.config.menu.label.hiddenMenu': 'Hidden Menu',
	'app.config.menu.label.i18n': 'i18n',
	'app.config.menu.label.menuPath': 'Menu Path',
	'app.config.menu.placeholder.menuPath': 'Please enter menu path',
	'app.config.notice.title': 'Notice Management',
	'app.config.notice.detailTitle': 'Notice Detail',
	'app.config.notice.table.noticeId': 'Notice ID',
	'app.config.notice.table.title': 'Notice Title',
	'app.config.notice.table.content': 'Notice Content',
	'app.config.notice.label.title': 'Notice Title',
	'app.config.notice.label.content': 'Notice Content',
	'app.config.notice.placeholder.content': 'Please enter notice content here...',
	'app.config.schedule.title': 'Batch Processing Management',
	'app.config.schedule.detailTitle': 'Batch Processing Detail',
	'app.config.schedule.table.jobName': 'Job Name',
	'app.config.schedule.table.jobGroup': 'Job Group',
	'app.config.schedule.table.cronExpression': 'Cron Expression',
	'app.config.schedule.table.invokeTarget': 'Target Class',
	'app.config.schedule.table.status': 'Job Status',
	'app.config.schedule.aria.taskStatus': 'Toggle scheduled task',
	'app.config.schedule.button.execute': 'Execute',
	'app.config.schedule.label.jobName': 'Job Name',
	'app.config.schedule.label.jobGroup': 'Job Group',
	'app.config.schedule.label.cronExpression': 'Cron Expression',
	'app.config.schedule.label.invokeTarget': 'Target Method',
	'app.config.schedule.placeholder.jobName': 'Please enter job name',
	// Schedule log
	'app.config.schedule.button.log': 'Log',
	'app.config.schedule.log.table.jobName': 'Job Name',
	'app.config.schedule.log.table.jobGroup': 'Job Group',
	'app.config.schedule.log.table.startTime': 'Start Time',
	'app.config.schedule.log.table.endTime': 'End Time',
	'app.config.schedule.log.table.duration': 'Duration',
	'app.config.schedule.log.table.status': 'Status',
	'app.config.schedule.log.table.exception': 'Exception Stack',
	'app.config.schedule.log.table.createTime': 'Create Time',
	'app.config.schedule.log.label.jobName': 'Job Name',
	'app.config.schedule.log.label.jobGroup': 'Job Group',
	'app.config.schedule.log.label.status': 'Status',
	'app.config.schedule.log.label.time': 'Execute Time',
	'app.config.schedule.log.placeholder.jobName': 'Please enter job name',
	'app.config.schedule.log.placeholder.jobGroup': 'Please enter job group',
	'app.config.schedule.log.placeholder.status': 'Please select status',
	'app.config.schedule.log.placeholder.timeStart': 'Start Date',
	'app.config.schedule.log.placeholder.timeEnd': 'End Date',
	'app.config.schedule.log.status.success': 'Success',
	'app.config.schedule.log.status.fail': 'Failed',
	'app.config.schedule.log.button.viewFull': 'View Full',
	'app.config.schedule.log.modal.exception': 'Exception Stack',
	// User related
	'app.user.center.title': 'User Center',
	// Logs related
	'app.logs.title': 'Log Management',
	'app.logs.table.logType': 'Log Type',
	'app.logs.table.userId': 'User ID',
	'app.logs.table.logContent': 'Log Content',
	'app.logs.table.logModule': 'Log Module',
	'app.logs.table.logThread': 'Log Thread',
	'app.logs.table.exception': 'Exception Stack',
	'app.logs.table.ip': 'IP',
	'app.logs.label.desc': 'Log Description',
	'app.logs.placeholder.desc': 'Please enter log description',
	// 主题设置
	'app.theme.title': 'Theme Settings',
	'app.theme.section.color': 'System Theme Color',
	'app.theme.section.style': 'Theme Style',
	'app.theme.section.width': 'Container Width',
	'app.theme.section.basic': 'Basic Config',
	'app.theme.appearanceMode': 'Appearance Mode',
	'app.theme.dark': 'Dark',
	'app.theme.light': 'Light',
	'app.theme.language': 'Language',
	'app.theme.comingSoon': 'Coming soon',
	'app.theme.hue.blue': 'Blue',
	'app.theme.hue.violet': 'Violet',
	'app.theme.hue.indigo': 'Indigo',
	'app.theme.hue.teal': 'Teal',
	'app.theme.hue.amber': 'Amber',
	'app.theme.hue.pink': 'Pink',
	'app.theme.section.global': 'System Config',
	'app.theme.section.seo': 'SEO Config',
	'app.theme.watermark': 'Global Watermark',
	'app.theme.style.system': 'Follow System',
	'app.theme.width.compact': 'Compact',
	'app.theme.width.medium': 'Medium',
	'app.theme.width.spacious': 'Spacious',
	'app.theme.systemName': 'System Name',
	'app.theme.copyright': 'Copyright',
	'app.theme.siderWidth': 'Sider Width',
	'app.theme.seo.title': 'SEO Title',
	'app.theme.seo.keywords': 'SEO Keywords',
	'app.theme.seo.description': 'SEO Description',
	// Online users
	'app.monitor.online.table.id': 'ID',
	'app.monitor.online.table.userId': 'User ID',
	'app.monitor.online.table.username': 'Username',
	'app.monitor.online.table.loginIp': 'Login IP',
	'app.monitor.online.table.browser': 'Browser',
	'app.monitor.online.table.os': 'OS',
	'app.monitor.online.table.device': 'Device',
	'app.monitor.online.table.userAgent': 'User-Agent',
	'app.monitor.online.table.token': 'Token',
	'app.monitor.online.table.loginTime': 'Login Time',
	'app.monitor.online.table.lastActive': 'Last Active',
	'app.monitor.online.detail.title': 'Online User Detail',
	'app.monitor.online.detail.section.basic': 'Basic Info',
	'app.monitor.online.detail.section.session': 'Session Info',
	'app.monitor.online.detail.section.meta': 'Timestamp & Device Fingerprint',
	'app.monitor.online.button.kickout': 'Kick Out',
	'app.monitor.online.button.refresh': 'Refresh',
	'app.monitor.online.confirm.kickout.title': 'Are you sure to kick out this user?',
	'app.monitor.online.confirm.kickout.content': 'Please confirm, the session will be invalidated immediately',
	'app.monitor.online.confirm.kickout.okText': 'Kick out',
	'app.monitor.online.placeholder.username': 'Please enter username',
	'app.monitor.online.placeholder.loginIp': 'Please enter login IP',
	// Server monitor
	'app.monitor.server.title': 'Server',
	'app.monitor.server.runtime': 'Runtime',
	'app.monitor.server.usage': 'Resource Usage',
	'app.monitor.server.cpu': 'CPU Usage',
	'app.monitor.server.cores': 'Cores',
	'app.monitor.server.used': 'Used',
	'app.monitor.server.memory': 'Memory Usage',
	'app.monitor.server.total': 'Total',
	'app.monitor.server.free': 'Free',
	'app.monitor.server.disk': 'Disk Usage',
	'app.monitor.server.jvm': 'JVM Info',
	'app.monitor.server.jvmName': 'Name',
	'app.monitor.server.jvmVersion': 'Version',
	'app.monitor.server.jvmHome': 'Home',
	'app.monitor.server.sys': 'System Info',
	'app.monitor.server.osName': 'OS',
	'app.monitor.server.osArch': 'Arch',
	'app.monitor.server.osVersion': 'OS Version',
	'app.monitor.server.hostName': 'Host Name',
	'app.monitor.server.ipAddress': 'IP Address',
	'app.monitor.server.uptime': 'System Uptime',
	'app.monitor.server.cache': 'Cache',
	// Cache monitor (merged into Server page)
	'app.monitor.cache.hitRate': 'Cache Hit Rate',
	'app.monitor.cache.hits': 'Hits',
	'app.monitor.cache.misses': 'Misses',
	'app.monitor.cache.usedMemory': 'Cache Memory',
	'app.monitor.cache.keyCount': 'Key Count',
	'app.monitor.cache.used': 'Used',
	'app.monitor.cache.total': 'Total',
	'app.monitor.cache.size': 'Size',
	'app.monitor.cache.usage': 'Usage',
	// Server monitor — KPI short labels & trend captions
	'app.monitor.server.kpi.cpu': 'CPU',
	'app.monitor.server.kpi.memory': 'Memory',
	'app.monitor.server.kpi.disk': 'Disk',
	'app.monitor.server.kpi.cache': 'Cache',
	'app.monitor.server.trend.recent5min': 'Last 5 Min',
	'app.monitor.server.trend.latest': 'Current',
	'app.monitor.server.trend.uptime': 'Uptime',
	// Server monitor — pie segment labels
	'app.monitor.server.pie.used': 'Used',
	'app.monitor.server.pie.free': 'Free',
	// In-site messages
	'app.message.title': 'Messages',
	'app.message.empty': 'No unread messages',
	'app.message.markAllRead': 'Mark all as read',
	'app.message.viewAll': 'View all',
	'app.message.scope.all': 'All users',
	'app.message.scope.user': 'Specific users',
	'app.message.scope.dept': 'Specific departments',
	'app.message.status.read': 'Read',
	'app.message.status.unread': 'Unread',
	'app.message.tab.list': 'Message List',
	'app.message.tab.create': 'New Message',
	'app.message.detail.title': 'Message Detail',
	'app.message.table.title': 'Title',
	'app.message.table.content': 'Preview',
	'app.message.table.scope': 'Scope',
	'app.message.table.sender': 'Sender',
	'app.message.table.recipientCount': 'Recipients',
	'app.message.table.readCount': 'Read',
	'app.message.table.read': 'Read Status',
	'app.message.label.title': 'Title',
	'app.message.label.scope': 'Recipients',
	'app.message.label.recipient': 'Recipient',
	'app.message.label.recipientDept': 'Department',
	'app.message.label.content': 'Content',
	'app.message.placeholder.title': 'Enter title',
	'app.message.placeholder.titleQuery': 'Search by title',
	'app.message.placeholder.scope': 'Filter by scope',
	'app.message.placeholder.recipient': 'Pick recipients (searchable)',
	'app.message.placeholder.recipientDept': 'Pick departments',
	'app.message.placeholder.content': 'Enter content...',
	'app.message.error.title.required': 'Title is required',
	'app.message.error.recipient.required': 'Please pick at least one recipient',
	'app.message.error.recipientDept.required': 'Please pick at least one department',
	// AI — MCP server management
	'app.ai.mcp.title': 'MCP Servers',
	// Query
	'app.ai.mcp.query.name': 'Name',
	'app.ai.mcp.query.namePlaceholder': 'Please enter name',
	'app.ai.mcp.query.protocol': 'Protocol',
	'app.ai.mcp.query.protocolPlaceholder': 'Select protocol',
	'app.ai.mcp.query.status': 'Status',
	'app.ai.mcp.query.statusPlaceholder': 'Select status',
	// Table columns
	'app.ai.mcp.table.id': 'ID',
	'app.ai.mcp.table.name': 'Name',
	'app.ai.mcp.table.protocol': 'Protocol',
	'app.ai.mcp.table.enabled': 'Status',
	'app.ai.mcp.table.connStatus': 'Connection',
	'app.ai.mcp.table.target': 'Endpoint / Command',
	'app.ai.mcp.table.lastTest': 'Last Test',
	'app.ai.mcp.table.lastCheckTime': 'Last Test Time',
	'app.ai.mcp.table.lastCostMs': 'Cost',
	'app.ai.mcp.table.updateTime': 'Update Time',
	// Protocol
	'app.ai.mcp.protocol.sse': 'SSE',
	'app.ai.mcp.protocol.streamableHttp': 'Streamable HTTP',
	'app.ai.mcp.protocol.stdio': 'STDIO',
	'app.ai.mcp.tab.sse': 'SSE',
	'app.ai.mcp.tab.streamableHttp': 'Streamable HTTP',
	'app.ai.mcp.tab.stdio': 'STDIO',
	// Enabled status
	'app.ai.mcp.enabled.on': 'Enabled',
	'app.ai.mcp.enabled.off': 'Disabled',
	// Connection status
	'app.ai.mcp.conn.connected': 'Connected',
	'app.ai.mcp.conn.disconnected': 'Disconnected',
	'app.ai.mcp.conn.unknown': 'Unknown',
	// Buttons
	'app.ai.mcp.button.tools': 'Tools',
	'app.ai.mcp.button.test': 'Test Connection',
	// Delete / test tips
	'app.ai.mcp.confirm.delete.title': 'Are you sure to delete this MCP server?',
	'app.ai.mcp.confirm.delete.content': 'Please confirm, this cannot be undone',
	'app.ai.mcp.test.success': 'Connection succeeded',
	'app.ai.mcp.test.fail': 'Connection failed',
	'app.ai.mcp.test.disabledTip': 'This server is disabled, please enable it before testing',
	// Detail form
	'app.ai.mcp.detail.createTitle': 'New MCP Server',
	'app.ai.mcp.detail.editTitle': 'Edit MCP Server',
	'app.ai.mcp.detail.viewTitle': 'MCP Server Detail',
	'app.ai.mcp.form.name': 'Name',
	'app.ai.mcp.form.namePlaceholder': 'Please enter name',
	'app.ai.mcp.form.description': 'Description',
	'app.ai.mcp.form.descriptionPlaceholder': 'Please enter description',
	'app.ai.mcp.form.protocol': 'Protocol',
	'app.ai.mcp.form.enabled': 'Enabled',
	// SSE fields
	'app.ai.mcp.form.sse.url': 'Endpoint URL',
	'app.ai.mcp.form.sse.urlPlaceholder': 'Please enter an HTTP/HTTPS URL',
	'app.ai.mcp.form.sse.headers': 'Headers',
	'app.ai.mcp.form.sse.timeout': 'Timeout (seconds)',
	'app.ai.mcp.form.streamableHttp.url': 'Endpoint URL',
	'app.ai.mcp.form.streamableHttp.urlPlaceholder': 'Please enter an HTTP/HTTPS URL',
	'app.ai.mcp.form.streamableHttp.headers': 'Headers',
	'app.ai.mcp.form.streamableHttp.timeout': 'Timeout (seconds)',
	// STDIO fields
	'app.ai.mcp.form.stdio.command': 'Command',
	'app.ai.mcp.form.stdio.commandPlaceholder': 'Enter the command (trusted commands only)',
	'app.ai.mcp.form.stdio.commandSafety':
		'STDIO runs local commands on the server. Only configure trusted commands to avoid injection risks.',
	'app.ai.mcp.form.stdio.args': 'Arguments',
	'app.ai.mcp.form.stdio.env': 'Environment Variables',
	'app.ai.mcp.form.stdio.cwd': 'Working Directory',
	'app.ai.mcp.form.stdio.cwdPlaceholder': 'Working directory (optional)',
	// Dynamic key-value
	'app.ai.mcp.kv.key': 'Key',
	'app.ai.mcp.kv.value': 'Value',
	'app.ai.mcp.kv.add': 'Add',
	'app.ai.mcp.kv.arg': 'Argument',
	// Validation
	'app.ai.mcp.error.name.required': 'Name is required',
	'app.ai.mcp.error.name.pattern': 'Only letters, digits, underscore and hyphen are allowed',
	'app.ai.mcp.error.protocol.required': 'Please select a protocol',
	'app.ai.mcp.error.url.required': 'Endpoint URL is required',
	'app.ai.mcp.error.url.pattern': 'Please enter a valid HTTP/HTTPS URL',
	'app.ai.mcp.error.timeout.range': 'Timeout must be between 1 and 120 seconds',
	'app.ai.mcp.error.command.required': 'Command is required',
	'app.ai.mcp.error.kv.duplicate': 'Duplicate keys exist',
	// Test-before-save hint
	'app.ai.mcp.form.testSavedOnly': 'Connection test is only available for saved servers. Please save first.',
	'app.ai.mcp.form.testButton': 'Test Connection',
	// Tools browser
	'app.ai.mcp.tools.title': 'Tools Browser',
	'app.ai.mcp.tools.listTitle': 'Tools',
	'app.ai.mcp.tools.empty': 'No tools available',
	'app.ai.mcp.tools.schemaTitle': 'Input Schema',
	'app.ai.mcp.tools.noSchema': 'This tool has no input schema',
	'app.ai.mcp.tools.selectHint': 'Select a tool from the left',
	'app.ai.mcp.tools.paramsTitle': 'Arguments (JSON)',
	'app.ai.mcp.tools.format': 'Format',
	'app.ai.mcp.tools.call': 'Call',
	'app.ai.mcp.tools.resultTitle': 'Result',
	'app.ai.mcp.tools.noResult': 'No result yet',
	'app.ai.mcp.tools.error.invalidJson': 'Arguments are not valid JSON',
	'app.ai.mcp.tools.error.notObject': 'The top-level of arguments must be an object',
	'app.ai.mcp.tools.disabledTip': 'This server is disabled, tools browser is unavailable',
	// AI — LLM Providers (OpenAI compatible)
	'app.ai.llm.providers.title': 'LLM Providers',
	// Query
	'app.ai.llm.providers.query.name': 'Name',
	'app.ai.llm.providers.query.namePlaceholder': 'Search by name',
	'app.ai.llm.providers.query.provider': 'Vendor',
	'app.ai.llm.providers.query.providerPlaceholder': 'Select vendor',
	'app.ai.llm.providers.query.status': 'Status',
	'app.ai.llm.providers.query.statusPlaceholder': 'Select status',
	// Table columns
	'app.ai.llm.providers.table.id': 'ID',
	'app.ai.llm.providers.table.name': 'Name',
	'app.ai.llm.providers.table.provider': 'Vendor',
	'app.ai.llm.providers.table.modelName': 'Model',
	'app.ai.llm.providers.table.baseUrl': 'Endpoint',
	'app.ai.llm.providers.table.enabled': 'Enabled',
	'app.ai.llm.providers.table.connStatus': 'Status',
	'app.ai.llm.providers.table.lastTest': 'Last Test',
	'app.ai.llm.providers.table.lastCheckTime': 'Last Test Time',
	'app.ai.llm.providers.table.lastCostMs': 'Cost',
	'app.ai.llm.providers.table.updateTime': 'Update Time',
	// Vendor
	'app.ai.llm.providers.vendor.anthropic': 'Anthropic',
	'app.ai.llm.providers.vendor.openai': 'OpenAI',
	'app.ai.llm.providers.vendor.deepseek': 'DeepSeek',
	'app.ai.llm.providers.vendor.zai': 'Z.AI',
	'app.ai.llm.providers.vendor.custom': 'Custom',
	// Connection status
	'app.ai.llm.providers.conn.online': 'Online',
	'app.ai.llm.providers.conn.offline': 'Offline',
	'app.ai.llm.providers.conn.unknown': 'Unknown',
	'app.ai.llm.providers.conn.disabled': 'Disabled',
	// Enabled status
	'app.ai.llm.providers.enabled.on': 'Enabled',
	'app.ai.llm.providers.enabled.off': 'Disabled',
	// Test
	'app.ai.llm.providers.test.success': 'Connected',
	'app.ai.llm.providers.test.fail': 'Failed to connect',
	'app.ai.llm.providers.test.disabledTip': 'This provider is disabled, please enable it before testing',
	// Detail
	'app.ai.llm.providers.detail.createTitle': 'New Model Provider',
	'app.ai.llm.providers.detail.editTitle': 'Edit Model Provider',
	'app.ai.llm.providers.detail.viewTitle': 'Model Provider Detail',
	// Buttons
	'app.ai.llm.providers.button.test': 'Test',
	// Delete confirm
	'app.ai.llm.providers.confirm.delete.title': 'Are you sure to delete this model provider?',
	'app.ai.llm.providers.confirm.delete.content': 'Please confirm, this cannot be undone',
	// Detail form
	'app.ai.llm.providers.form.name': 'Name',
	'app.ai.llm.providers.form.namePlaceholder': 'Enter a unique alias (globally unique)',
	'app.ai.llm.providers.form.provider': 'Vendor',
	'app.ai.llm.providers.form.modelName': 'Model',
	'app.ai.llm.providers.form.modelNamePlaceholder': 'Enter model name (e.g., claude-sonnet-4.5)',
	'app.ai.llm.providers.form.baseUrl': 'Endpoint',
	'app.ai.llm.providers.form.baseUrlPlaceholder': 'OpenAI-compatible endpoint, must end with /v1',
	'app.ai.llm.providers.form.apiKeyCipher': 'API KEY',
	'app.ai.llm.providers.form.apiKeyCipherPlaceholder': 'Enter API KEY (plaintext, AES-encrypted by server)',
	'app.ai.llm.providers.form.apiKeyEdit': 'Edit',
	'app.ai.llm.providers.form.enabled': 'Enabled',
	'app.ai.llm.providers.form.testButton': 'Test',
	// Detail section titles
	'app.ai.llm.providers.detail.section.basic': 'Basic Info',
	'app.ai.llm.providers.detail.section.config': 'API Config',
	// Validation
	'app.ai.llm.providers.error.name.required': 'Name is required',
	'app.ai.llm.providers.error.name.pattern': 'Only letters, digits, underscore and hyphen are allowed',
	'app.ai.llm.providers.error.provider.required': 'Please select a vendor',
	'app.ai.llm.providers.error.modelName.required': 'Model name is required',
	'app.ai.llm.providers.error.baseUrl.required': 'Endpoint is required',
	'app.ai.llm.providers.error.baseUrl.pattern': 'Endpoint must end with /v1',
	'app.ai.llm.providers.error.apiKeyCipher.required': 'API KEY is required',
	// AI — Training Ground
	'app.ai.training.title': 'Training Ground',
	'app.ai.training.desc': 'Pick a model and MCP tools to start a conversation',
	'app.ai.training.config.provider': 'Model',
	'app.ai.training.config.thinking': 'Thinking / reasoning',
	'app.ai.training.config.providerPlaceholder': 'Select a model',
	'app.ai.training.config.mcp': 'MCP Tools',
	'app.ai.training.config.mcpPlaceholder': 'Pick MCP tools to inject (multi-select)',
	'app.ai.training.config.clear': 'Clear chat',
	'app.ai.training.config.prompt': 'System Prompt',
	'app.ai.training.config.promptPlaceholder': 'Pick a system prompt to inject',
	'app.ai.training.input.placeholder': 'Type a message...',
	'app.ai.training.send': 'Send',
	'app.ai.training.stop': 'Stop',
	'app.ai.training.error.noProvider': 'Please pick a model first',
	'app.ai.training.error.noMessage': 'Please type a message',
	'app.ai.training.error.streamError': 'Connection error, please retry',
	'app.ai.training.role.user': 'You',
	'app.ai.training.role.assistant': 'Assistant',
	'app.ai.training.toolbar.h5Jump': 'Mobile View',
	'app.ai.training.toolbar.h5JumpDesc':
		'Open H5 training in a new window (press F12 → toggle device toolbar / Ctrl+Shift+M to emulate mobile)',
	// AI — Prompt Management
	'app.ai.llm.prompts.title': 'Prompts',
	// Query
	'app.ai.llm.prompts.query.name': 'Name',
	'app.ai.llm.prompts.query.namePlaceholder': 'Search by name',
	'app.ai.llm.prompts.query.category': 'Category',
	'app.ai.llm.prompts.query.categoryPlaceholder': 'Select category',
	'app.ai.llm.prompts.query.enabled': 'Status',
	'app.ai.llm.prompts.query.enabledPlaceholder': 'Select status',
	// Table columns
	'app.ai.llm.prompts.table.id': 'ID',
	'app.ai.llm.prompts.table.name': 'Name',
	'app.ai.llm.prompts.table.category': 'Category',
	'app.ai.llm.prompts.table.description': 'Description',
	'app.ai.llm.prompts.table.content': 'Preview',
	'app.ai.llm.prompts.table.enabled': 'Enabled',
	'app.ai.llm.prompts.table.updateTime': 'Update Time',
	// Enabled status
	'app.ai.llm.prompts.enabled.on': 'Enabled',
	'app.ai.llm.prompts.enabled.off': 'Disabled',
	// Detail
	'app.ai.llm.prompts.detail.createTitle': 'New Prompt',
	'app.ai.llm.prompts.detail.editTitle': 'Edit Prompt',
	'app.ai.llm.prompts.detail.viewTitle': 'Prompt Detail',
	'app.ai.llm.prompts.detail.section.basic': 'Basic Info',
	'app.ai.llm.prompts.detail.section.content': 'Content',
	// Form
	'app.ai.llm.prompts.form.name': 'Name',
	'app.ai.llm.prompts.form.namePlaceholder': 'Enter a unique alias (globally unique)',
	'app.ai.llm.prompts.form.category': 'Category',
	'app.ai.llm.prompts.form.categoryPlaceholder': 'Pick or type a category',
	'app.ai.llm.prompts.form.description': 'Description',
	'app.ai.llm.prompts.form.descriptionPlaceholder': 'Describe the use case',
	'app.ai.llm.prompts.form.content': 'System Prompt Content',
	'app.ai.llm.prompts.form.contentPlaceholder': 'Enter the system prompt (plain text)',
	'app.ai.llm.prompts.form.enabled': 'Enabled',
	// Validation
	'app.ai.llm.prompts.error.name.required': 'Name is required',
	'app.ai.llm.prompts.error.name.pattern': 'Only letters, digits, underscore and hyphen are allowed',
	'app.ai.llm.prompts.error.content.required': 'Content is required',
	// Training ground dropdown
	'app.ai.llm.prompts.option.none': 'No prompt',
	// Delete confirm
	'app.ai.llm.prompts.confirm.delete.title': 'Are you sure to delete this prompt?',
	'app.ai.llm.prompts.confirm.delete.content': 'Please confirm, this cannot be undone',
	// H5 — Mobile training ground
	'app.h5.training': 'AI Training (H5)',
	'app.h5.training.title': 'AI Training',
	'app.h5.training.providerPlaceholder': 'Select a model',
	'app.h5.training.input.placeholder': 'Type a message...',
	'app.h5.training.send': 'Send',
	'app.h5.training.stop': 'Stop',
	'app.h5.training.error.noProvider': 'Please pick a model first',
	'app.h5.training.error.noMessage': 'Please type a message',
	'app.h5.training.error.streamError': 'Connection error, please retry',
	'app.h5.training.devtoolsBanner':
		'Viewing as mobile in a desktop browser? Press F12 to open DevTools → click the "Toggle device toolbar" icon (Ctrl+Shift+M) and pick a phone profile. This banner only shows on desktop.'
}
